import { FC } from 'react';
import { Entity, ID } from 'api/domain/types';

import { PopulatedPriceListAssociation } from 'domain/entities/PopulatedPriceListAssociation';
import { useCaseDeleteAssociation } from 'application/prices/useCases/useCaseDeleteAssociation';
import { useCaseSearchAssociations } from 'application/prices/useCases/useCaseSearchAssociations';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { ConfirmationModal, IconButton, TrashCanIcon } from 'targets/web/components';

const DeleteAssociationButton: FC<{
  priceListId: ID;
  association: Entity<PopulatedPriceListAssociation>;
}> = ({ association }) => {
  const t = useTranslationPrefix('configuration.price_list_details.associations_table');
  const { deleteAssociation } = useCaseDeleteAssociation();
  const { refetch } = useCaseSearchAssociations();

  const onDelete = async () => {
    await deleteAssociation({ associationId: association.id });
    refetch();
  };

  return (
    <ConfirmationModal
      title={t('delete_confirm_title')}
      subtitle={t('delete_confirm_subtitle')}
      confirmButtonColor="error"
      onConfirm={onDelete}
      triggerButton={(onClick) => (
        <IconButton
          variant="outlined"
          color="error"
          onClick={onClick}
          aria-label="Delete association"
        >
          <TrashCanIcon width="24px" height="24px" />
        </IconButton>
      )}
    />
  );
};

export default DeleteAssociationButton;
